import { http } from '@/utils'

export const scheduleSettingMobile = (params?: any) =>
  http.get(`/schedule/setting/mobile`, {
    data: params
  })
